import { StatisticsPeriod } from './types';
import dayjs from 'dayjs';

export const chartDateFormatter = (period: StatisticsPeriod | null) => (
  data: string
) => {
  const date = dayjs(data);
  if (!date.isValid()) {
    return data;
  }

  if (period === 'lastDay' || period === 'today') {
    return date.format('HH:mm');
  } else {
    return date.format('DD-MM');
  }
};

export const generateConfig = (
  data: any,
  xField: string,
  yField: string,
  xTitle: string,
  yTitle: string,
  xAxisFormatter: (data: any) => string,
  specificConfig: Record<string, any> = {}
) => ({
  animation: false,
  xField,
  yField,
  data,
  forceFit: true,
  padding: 'auto',
  xAxis: {
    visible: true,
    label: { autoHide: true, formatter: xAxisFormatter },
    title: { text: xTitle },
  },
  yAxis: {
    visible: true,
    label: {
      visible: true,
    },
    title: {
      text: yTitle,
    },
  },
  responsive: true,
  ...specificConfig,
});
